/** 展开/收起动画时长，须与 components/motion.css 里的 --motion-dur 保持一致 */
const EXPAND_MS = 240
/** 摘掉标记的宽限期，比动画略长，避免动画结尾的一帧被过早解除裁剪 */
const SETTLE_MS = 60

/**
 * 给全站 `<details>` 挂上展开动效所需的运行时标记。
 *
 * 为什么需要它：`::details-content` 的高度过渡必须配合 `overflow: hidden` 才能
 * 裁剪内容，但常驻裁剪会把绝对定位的浮层（例如作战配置的关卡下拉菜单）一起切掉。
 * 所以只在动画进行中加 `.motion-expanding`，动画结束后立刻摘掉。
 *
 * `toggle` 事件不冒泡，因此必须用捕获阶段监听。
 *
 * @returns 卸载函数（组件 unmount 时调用）
 */
export function installExpandMotion(): () => void {
  if (typeof document === "undefined") return () => {}

  const timers = new WeakMap<HTMLDetailsElement, number>()

  const onToggle = (event: Event) => {
    const element = event.target
    if (!(element instanceof HTMLDetailsElement)) return

    element.classList.add("motion-expanding")
    const previous = timers.get(element)
    if (previous !== undefined) window.clearTimeout(previous)
    timers.set(
      element,
      window.setTimeout(() => {
        element.classList.remove("motion-expanding")
        timers.delete(element)
      }, EXPAND_MS + SETTLE_MS),
    )
  }

  document.addEventListener("toggle", onToggle, true)
  return () => document.removeEventListener("toggle", onToggle, true)
}
